module.exports = __webpack_public_path__ + "static/media/home-card3.6f5af505.png";